module.exports = __webpack_public_path__ + "static/media/Data Asset Page Icons-06.cf7ca6c7.svg";